module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/caregram-0552945dc4bfba2252ba5d0f7ff04a90.svg";